import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { goaBeachCityData } from './tourPackageData'

function GoaBeachCity() {
    return (
        <>
            <Header />
            <CommonHeroSection title="GOA Beach City" />
            <CommonBreadcrumb items={["GOA Beach City"]} />
            <DynamicTourSection {...goaBeachCityData} />
            <Footer />
        </>
    )
}

export default GoaBeachCity